// custom-collections.js - habilita "click + arrastre" en desktop
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.grid.grid--uniform').forEach(function (slider) {
    let isDown = false;
    let startX;
    let scrollLeft;

    // cursor por defecto
    slider.style.cursor = 'grab';

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.getBoundingClientRect().left;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
    });

    ['mouseup', 'mouseleave'].forEach(function(evt) {
      slider.addEventListener(evt, function () {
        isDown = false;
        slider.classList.remove('dragging');
        slider.style.cursor = 'grab';
      });
    });

    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.getBoundingClientRect().left;
      const walk = (x - startX) * 1.5; // ajusta velocidad aquí si quieres
      slider.scrollLeft = scrollLeft - walk;
    });
  });
});
